import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPixelPageView } from '@/lib/metaPixel';

/** Fires `fbq('track', 'PageView')` on every SPA route change.
 *  Skips the very first pageview because /public/index.html already fired it. */
const MetaPixelRouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Skip the initial mount — index.html already fired PageView on load.
    if (window.__metaPixelInitialPageviewSent) {
      trackPixelPageView();
    } else {
      window.__metaPixelInitialPageviewSent = true;
    }
  }, [location.pathname, location.search]);

  return null;
};

export default MetaPixelRouteTracker;
